<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6BffaG/tc-custom/9780897339582.jpg?1705201909680" alt="This image is the cover for the book Nibble & Kuhn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nibble & Kuhn
      </h1>
      <p class="bookDescription body article font2">
        <b>From the award-winning author of <i>Empire Settings</i>, “skilled character development guides this courtroom potboiler to a neat finish” (<i>Publishers Weekly</i>).</b><br/>  <br/> An unraveling law firm. An unwinnable case. An unworkable love. Derek Dover has it all. Derek’s up for partner at Nibble &amp; Kuhn just as that most proper of Boston law firms comically tries to ‘rebrand’ itself for the Google era. Pompous and arbitrary, the ruling junta of partners saddles him with a high visibility lawsuit just weeks before trial. The diligent young attorney arranges things so that Maria Parma, a new associate in the firm for whom he’s fallen hard, also gets named to the case. Maria, in turn, can’t keep her hands off Derek, but it’s complicated because she’s engaged to someone else. As Derek prepares his case on behalf of seven young victims of an industrial polluter, his anxieties about his career and his torments over Maria’s mixed messages only increase. Ultimately, Derek sets into motion a line of inquiry that spins events entirely out of the control of the judge, jury, and all attorneys.<br/>  <br/> “Schmahmann . . . takes a sardonic look at the law and justice in this smoothly told love story.”<br/>  —<i>Booklist</i><br/>  <br/> “David Schmahmann tells a wonderful story, and he tells it brilliantly. I expect great success for <i>Nibble and Kuhn</i> and I won’t even be jealous if it arrives.” <i>—New York Times–</i>bestselling author Robert B. Parker 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Schmahmann
      </h2>
      
      <p class="authorDescription body article">David Schmahmann was born in Durban, South Africa. He is a graduate of Dartmouth College and the Cornell Law School and has studied in India and Israel and worked in Burma. He practices law in Boston. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chicago Review Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6496b887